module.exports = __webpack_public_path__ + "img/leaf1.14456e24.png";